var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginsuccess-container"},[_c('p',[_vm._v("404 Page not Found")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Go Back to Login")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }